var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _path5, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroundPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 105,
    viewBox: "0 0 155 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.6262,
    y: 72.7282,
    width: 11.0896,
    height: 24.1307,
    rx: 3.33396,
    transform: "rotate(16.1664 61.6262 72.7282)",
    fill: "#DFEAED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0896,
    height: 24.1307,
    rx: 3.33396,
    transform: "matrix(-0.960457 0.278428 0.278428 0.960457 121.386 69.3513)",
    fill: "#DFEAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.496 5.33396C112.496 3.49267 111.003 2 109.162 2H67.4875C65.6462 2 64.1535 3.49266 64.1535 5.33396V14.5023H61.6533C59.1338 14.5023 57.0495 16.3655 56.7029 18.7892H48.2666C48.0879 16.1896 45.9225 14.1362 43.2775 14.1362H33.6199C23.0632 14.1362 13.2329 19.511 7.53541 28.3981C0.154863 39.9104 0.154862 54.6668 7.53541 66.1791C13.2329 75.0662 23.0632 80.441 33.6199 80.441H43.2775C45.5128 80.441 47.4055 78.9746 48.0461 76.9513H56.9152C57.5837 78.9264 59.4525 80.3481 61.6533 80.3481H147.503C150.265 80.3481 152.504 78.1091 152.504 75.3471V19.5033C152.504 16.7413 150.265 14.5023 147.503 14.5023H112.496V5.33396Z",
    fill: "#DFEAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1535 14.5023V16.1693H65.8205V14.5023H64.1535ZM56.7029 18.7892V20.4562H58.1485L58.3531 19.0251L56.7029 18.7892ZM48.2666 18.7892L46.6035 18.9035L46.7102 20.4562H48.2666V18.7892ZM7.53541 28.3981L8.93876 29.2978L7.53541 28.3981ZM7.53541 66.1791L8.93876 65.2794L7.53541 66.1791ZM48.0461 76.9513V75.2843H46.8254L46.4569 76.4481L48.0461 76.9513ZM56.9152 76.9513L58.4942 76.4169L58.1109 75.2843H56.9152V76.9513ZM112.496 14.5023H110.829V16.1693H112.496V14.5023ZM109.162 3.66698C110.083 3.66698 110.829 4.41332 110.829 5.33396H114.163C114.163 2.57202 111.924 0.333019 109.162 0.333019V3.66698ZM67.4875 3.66698H109.162V0.333019H67.4875V3.66698ZM65.8205 5.33396C65.8205 4.41331 66.5668 3.66698 67.4875 3.66698V0.333019C64.7255 0.333019 62.4865 2.57201 62.4865 5.33396H65.8205ZM65.8205 14.5023V5.33396H62.4865V14.5023H65.8205ZM64.1535 12.8353H61.6533V16.1693H64.1535V12.8353ZM61.6533 12.8353C58.2925 12.8353 55.515 15.3201 55.0527 18.5533L58.3531 19.0251C58.5839 17.4109 59.9751 16.1693 61.6533 16.1693V12.8353ZM56.7029 17.1222H48.2666V20.4562H56.7029V17.1222ZM49.9296 18.6749C49.6913 15.2071 46.8049 12.4692 43.2775 12.4692V15.8032C45.0402 15.8032 46.4845 17.172 46.6035 18.9035L49.9296 18.6749ZM43.2775 12.4692H33.6199V15.8032H43.2775V12.4692ZM33.6199 12.4692C22.4953 12.4692 12.1361 18.1332 6.13206 27.4984L8.93876 29.2978C14.3298 20.8888 23.6312 15.8032 33.6199 15.8032V12.4692ZM6.13206 27.4984C-1.6 39.559 -1.6 55.0182 6.13206 67.0788L8.93876 65.2794C1.90972 54.3154 1.90972 40.2618 8.93876 29.2978L6.13206 27.4984ZM6.13206 67.0788C12.1361 76.444 22.4953 82.108 33.6199 82.108V78.774C23.6312 78.774 14.3298 73.6884 8.93876 65.2794L6.13206 67.0788ZM33.6199 82.108H43.2775V78.774H33.6199V82.108ZM43.2775 82.108C46.2604 82.108 48.7816 80.1507 49.6353 77.4545L46.4569 76.4481C46.0293 77.7985 44.7652 78.774 43.2775 78.774V82.108ZM48.0461 78.6183H56.9152V75.2843H48.0461V78.6183ZM55.3362 77.4857C56.2268 80.1172 58.7163 82.0151 61.6533 82.0151V78.6811C60.1886 78.6811 58.9405 77.7356 58.4942 76.4169L55.3362 77.4857ZM61.6533 82.0151H147.503V78.6811H61.6533V82.0151ZM147.503 82.0151C151.185 82.0151 154.171 79.0297 154.171 75.3471H150.837C150.837 77.1884 149.344 78.6811 147.503 78.6811V82.0151ZM154.171 75.3471V19.5033H150.837V75.3471H154.171ZM154.171 19.5033C154.171 15.8207 151.185 12.8353 147.503 12.8353V16.1693C149.344 16.1693 150.837 17.662 150.837 19.5033H154.171ZM147.503 12.8353H112.496V16.1693H147.503V12.8353ZM110.829 5.33396V14.5023H114.163V5.33396H110.829Z",
    fill: "#234C69"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 15,
    width: 92,
    height: 64,
    rx: 1.66698,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4856 17.0028L57.4856 77.8477",
    stroke: "#234C69",
    strokeWidth: 3.33396
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.496 13.6689L64.9869 13.6689",
    stroke: "#234C69",
    strokeWidth: 3.33396
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9346 17.0028L47.6094 78.7349",
    stroke: "#234C69",
    strokeWidth: 3.33396
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.533,
    y: 91.5305,
    width: 11.0896,
    height: 127.104,
    rx: 3.33396,
    transform: "rotate(90 152.533 91.5305)",
    fill: "#DFEAED",
    stroke: "#234C69",
    strokeWidth: 3.33396
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundPump);
export default __webpack_public_path__ + "static/media/GroundPump.051c5e25e00c2584c2718da678073b74.svg";
export { ForwardRef as ReactComponent };